 <template>
    <div>
        <div class="event-month-header" v-if="event.monthHeader">
            <div>{{ event.monthHeader }}</div>
        </div>
        <div class="row event-card-wrapper col-12 pb-4 pb-md-3 mx-md-1">
            <div class="alert alert-error" v-if="isErrored">{{ errorMsg }}</div>
            <div class="event-date-wrapper col-12 col-md-3 pb-3 pb-md-0">
                <div class="event-month"><strong>{{ formattedEventData.calendarMonthText }}</strong></div>
                <div class="event-day"><strong>{{ formattedEventData.calendarDayText }}</strong></div>
                <div class="event-day-text"><strong>{{ formattedEventData.calendarDayString }}</strong></div>
            </div>
            <div class="divisory-line mx-4 my-0 my-md-3 mx-md-0"></div>
            <div class="event-details col-12 col-md-8 pl-4">
                <a class="event-title" href="#" @click.prevent="navigateToEvent()" target="_blank">
                    <div>
                        <h4>{{ event.title }}</h4>
                    </div>
                </a>
                <div class="d-inline-block">
                    <div class="event-topic" v-if="event.topic">{{ event.topic }}</div>
                </div>
                <div class="col-12 col-md-9 pl-md-1 px-0">
                    <div class="icon-wrapper">
                        <span>
                            <img src="@/assets/image/icon_time.svg" />
                        </span>
                        <div>
                        {{ formattedEventData.eventDescriptionText }}
                        </div>
                    </div>
                    <div class="d-inline-block">
                        <div class="icon-wrapper location-container" v-if="event.location">
                            <span>
                                <img src="@/assets/image/icon_location.svg" />
                            </span>
                            <div>{{ event.location }}</div>
                        </div>
                    </div>
                </div>
                <div class="event-add-to-calendar-btn" v-bind:class="{ disabled: addToCalendarBtnDisabled }">
                    <div class="icon-wrapper">
                        <span>
                            <img src="@/assets/image/icon_calendar.svg" />
                        </span>
                        <div v-if="isLoading" class="loading-spinner">
                            <img :src="spinnerUrl" alt="Loading Spinner" />
                        </div>
                        <div v-else @click="addEventToCalendar">
                            {{ addToCalendarBtnLabel }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>

<script>
import api from "@/api";
import moment from "moment";
import * as CONSTANTS from "@/store/constants";
import LoadingSpinnerSmall from "@/components/LoadingSpinnerSmall";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
    name: "event-feed-card",
    components: {
      LoadingSpinnerSmall
    },
    props: ["eventData", "isAddedToCalendar", "userEmail"],
    mixins: [HomebaseMixpanelMixin],
    data() {
        return {
            CONSTANTS,
            isLoading: false,
            isErrored: false,
            errorMsg: CONSTANTS.SERVER_ERROR_MESSAGE,

             // event meta data
            event: null,
            formattedEventData: null,
            startDate: "",
            endDate: "",
            isAllDay: false,

            // add to calendar
            addToCalendarBtnLabel: "",
            addToCalendarBtnDisabled: false,
            spinnerUrl: HH_COMPONENTS_URL + "/spinner.svg"
        }
    },
    created() {
        this.initializeEventCard();
    },
    methods: {
        initializeEventCard() {
            let e = this.eventData;
            this.event = e;
            this.addToCalendarBtnDisabled = this.isAddedToCalendar;
            this.setAddToCalendarBtnLabel();
            this.setEventDates(e.startDate, e.endDate, e.isAllDay);
            const calendarConfig = this.getCalendarConfig();
             
            this.formattedEventData = {
                title: e.title,
                calendarMonthText: calendarConfig.calendarMonthText,
                calendarDayText: calendarConfig.calendarDayText,
                calendarDayString: calendarConfig.calendarDayString,
                calendarDayNumber: calendarConfig.calendarDayNumber,
                eventDayText: calendarConfig.eventDayText,
                eventDescriptionText: calendarConfig.eventDescriptionText,
            };
        },
        setEventDates(startDateStr, endDateStr, isAllDayEvent) {
            this.startDate = moment.utc(startDateStr);
            this.endDate = moment.utc(endDateStr);
            this.isAllDay = isAllDayEvent;
        },

        setAddToCalendarBtnLabel() {
            this.addToCalendarBtnLabel = this.addToCalendarBtnDisabled ? "Event added to your calendar":  "Add to calendar";
        },

        getCalendarConfig() {
            let res = {};
            let eventStartDate = this.isAllDay ? this.startDate : this.startDate.local();
            let eventEndDate = this.isAllDay ? this.endDate : this.endDate.local();

            const startMonth = eventStartDate.format("MMM");
            const endMonth = eventEndDate.format("MMM");
            const isMultiMonth = startMonth != endMonth;

            const startDay = eventStartDate.date();
            const endDay = eventEndDate.date();
            const isMultiDay = startDay != endDay;

            // set month text
            res.calendarMonthText = isMultiMonth
                ? `${startMonth} - ${endMonth}`
                : startMonth;

            // set day text
            if (isMultiMonth) {
                res.calendarDayText = `${eventStartDate.format("D")} - ${eventEndDate.format("D")}`;
            } else if (isMultiDay) {
                res.calendarDayText = `${startDay} - ${endDay}`;
            } else {
                res.calendarDayText = startDay;
            }

            res.calendarDayString = eventStartDate.format("dddd");

            if(this.isAllDay) {
                res.eventDescriptionText = isMultiDay ?
                    `${eventStartDate.format('dddd, MMMM Do, YYYY')} - ${eventEndDate.format('dddd, MMMM Do, YYYY')}` :
                    `${eventStartDate.format('dddd, MMMM Do, YYYY')}`
            } else {
                res.eventDescriptionText = `${eventStartDate.format("h:mm A")} - ${eventEndDate.format("h:mm A")}`;
            }

            return res;
        },

        navigateToEvent() {
            let title = this.event.title;
            let url = this.event.url;
            let subevent = `${title} - ${url}`;
            this.trackEventsByInterestEventClick(subevent);
            window.open(url, Vue.prototype.$getAoneLinkTarget(url));
        },

        async addEventToCalendar() {
            if(!this.addToCalendarBtnDisabled) {
                this.isErrored = false;
                this.isLoading = true;
                
                setTimeout(async () => {
                    try {
                        this.event.endDate = this.event.isAllDay ? moment(this.endDate).add(1, 'minutes') : this.event.endDate;
                        const addEventToCalendarResponse = await api.addEventToCalendar(this.event);
                        if(addEventToCalendarResponse) {
                            const createEventResponse = await api.createCalendarEvent({
                                id: this.event.uniqueId,
                                endDate: this.event.endDate,
                                email: this.userEmail,
                                startDate: this.event.startDate,
                                title: this.event.title
                            });
                            
                            if(createEventResponse && createEventResponse.data && !!createEventResponse.data.data) {
                                this.addToCalendarBtnDisabled = true;
                                this.handleAddToCalendarMPTracking();
                                this.setAddToCalendarBtnLabel(createEventResponse && createEventResponse.data && !!createEventResponse.data.data);    
                            } else {
                                this.isErrored = true;
                            }
                        }
                        
                        this.isLoading = false;  
                    }
                    catch (error) {
                        this.isErrored = true;
                        this.isLoading = false;  
                    }
                }, "300");
            }
        },
        handleAddToCalendarMPTracking() {
            let title = this.event.title;
            let url = this.event.url;
            let subevent = `${title} - ${url}`;
            this.trackAddEventToCalendar(subevent);
        }
    }
}
</script>

<style scoped>
.event-month-header {
    font-size: 24px;
    font-weight: bold;
    margin: 20px 0;
    display: flex;
    align-items: center
}
.event-month-header:after {
  background: #D9D9D9;
  height: 2px;
  flex: 1;
  content: '';
  margin-left: 20px;
}
.event-card-wrapper {
    display: flex;
    border: 2px solid #D9D9D9;
    border-radius: 10px;
}

.event-date-wrapper {
    height: 100%;
    text-align: center;
    padding: 25px;
}
.event-month {
    font-size: 20px;
}
.event-day {
    font-size: 30px;
}
.event-day-text {
    font-size: 20px;
    margin-top: 40px;
}
.event-details {
    padding-top: 20px;
}
.event-title:link {
    text-decoration: inherit;
    color: var(--secondary-color) !important;
    cursor: auto;
}

.event-title:visited {
    text-decoration: inherit;
    color: var(--secondary-color) !important;
    cursor: auto;
}

.event-title:hover {
    cursor: pointer;
}
.event-topic {
    background: var(--tag-color);
    font-size: 12px;
    border-radius: 2px;
    padding: 2px 7px;
    font-family: artifaktElementRegular;
    font-weight: 600px;
    margin-top: 5px;
    margin-bottom: 15px;
}
.event-add-to-calendar-btn {
    margin-top: 15px;
    font-family: artifaktElementBold;
    font-size: 16px;
    color: var(--secondary-color);
}

.event-add-to-calendar-btn.disabled {
    color: #2BC275;
    cursor: auto;
}

.event-add-to-calendar-btn:hover {
  cursor: pointer;
  color: var(--secondary-color);
}
.event-add-to-calendar-btn.disabled:hover {
    color: #2BC275;
    cursor: auto;
}

.icon-wrapper {
  display: flex;
}
.icon-wrapper div {
  padding: 1px 10px;
}
.icon-wrapper span {
  border-style: none;
  background: #ffffff;
}
.location-container {
  margin-left: -3px;
  margin-top: 5px;
}
.location-container div {
  margin-top: 1px;
  margin-left: -2px;
}
.loading-spinner img {
  height: 23px;
  margin-left: 30px;
  justify-content: center;
}
.alert-error {
    width: 100%;
    margin-top: 15px;
    border-radius: 10px;
}
@media (min-width: 768px) {
    .divisory-line {
        border-right:2px solid #D9D9D9;
    }
}
@media (max-width: 768px) {
    .divisory-line{
        width:100%; 
        border-bottom:2px solid #D9D9D9;
    }
}
@media (max-width: 768px) {
    .event-card-wrapper {
        margin-left: 0.1rem;
    }
    .event-date-wrapper {
        display: flex;
        justify-content: center;
    }
    .event-month {
        font-size: 20px;
        padding-right: 5px;
    }
    .event-day {
        font-size: 20px;
        padding-right: 15px;
    }   
    .event-day-text {
        font-size: 20px;
        margin-top: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/eventsByInterests/EventFeedCard.vue